<div id="elapsed-time">
    <div class="condition-input l-h-24">
        <div class="text-select-group">
            <input type="text" [(ngModel)]="data.matchValue" [disabled]="disabled" [placeholder]="placeholder"
                (focus)="onInputFocus.emit()" (blur)="onInputBlur.emit()" />を
            <caremoni-select-box class="select-ans-type" [options]="comparitionOptions" [selectedValue]="data.comparition"
                [disabled]="disabled" (valueChange)="data.comparition = $event"></caremoni-select-box>
        </div>
        <input class="input-time" type="number" [(ngModel)]="data.count" min="1" step="1" [disabled]="disabled"
            (focus)="onInputFocus.emit()" (blur)="fixValue(); onInputBlur.emit()" (keydown)="validValue($event)" />回
        <div class="btn-delete-contain">
            <div *ngIf="isDeleteVisible && !disabled" (click)="deleteRow()" class="btn-delete-row">x</div>
        </div>
    </div>
</div>